module.exports = __webpack_public_path__ + "static/img/gkztc_logo_big.0c1cfbe4.png";